<template>
	<div id="productView">
		<CommonHeader></CommonHeader>
		<div class="productCenter">
			<div class="common-header">
				<img width="100%" :src="image_url" alt="产品" />
			</div>
			<!-- 中间内容 -->
			<el-row id="scroll" class="container">
				<!-- 回到顶部 -->
				<el-backtop></el-backtop>
				<!-- 左边内容 -->
				<el-col style="width: 230px;">
					<ProdcutMenu :pageStatus="2"></ProdcutMenu>
				</el-col>
				<!--  右边内容 -->
				<el-col :style="{ width: 1200 - 230 - 10 + 'px' }" style="margin-left: 10px;">
					<!-- 产品列表 -->
					<!-- <product></product> -->
					
					<!-- 产品介绍和型号 -->
					<ProductAndModel></ProductAndModel>
				</el-col>
			</el-row>
		</div>
		<CommonBottom></CommonBottom>
	</div>
</template>

<script>
	import CommonHeader from '../../components/CommonHeader.vue'
	import CommonBottom from '../../components/CommonBottom.vue'

	import ProdcutMenu from '../../components/ProductMenu.vue'
	// import Product from '../../components/Product.vue'
	import ProductAndModel from '../../components/ProductAndModel.vue'

	export default {
		name: "ProductView",
		components: {
			CommonHeader,
			ProdcutMenu,
			// Product,
			ProductAndModel,
			CommonBottom
		},

		data() {
			return {
				cur_lang: 'zh',
				image_url: null,
			};
		},

		created() {

			let cur_lang = localStorage.getItem("locale");
			if (cur_lang) {
				this.cur_lang = cur_lang
			}
			this.switchImage();
			
		},

		mounted() {
			window.location.hash = "#scroll"
			const that = this;
			window.addEventListener("setItem", function(e) {
				// console.log('监听到了~', e.newValue, e.oldValue);
				if (e.key == 'locale') {
					that.cur_lang = e.newValue;
					that.switchImage();
				}
			});
			
			// 判断当前设备为手机端
			if(screen.width < 1200) {
				// 参数：?solution_index=0&solution_sub_index=0
				console.log(location.search)
				// 移动端
				window.location.href = process.env.VUE_APP_DOMAIN_URL+ "h5/#/pages/productCenter/productCenter" + location.search
				return;
			}
		},


		methods: {
			switchImage: function() {
				let image = this.cur_lang == 'zh' ? require("@/assets/product_center/productcenter_img.png") : require(
					"@/assets/product_center/productcenter_img_en.png");

				this.image_url = image;
			},
		}
	};
</script>

<style>
	#productView {
		/* font-family: Avenir, Helvetica, Arial, sans-serif; */
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		color: #2c3e50;
		min-width: 1200px;
		min-height: 100%;

		text-align: center;
		padding-bottom: 160px;

		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: center;

		position: relative;
	}

	.productCenter {
		width: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}

	.common-header {
		width: 100%;
	}

	.container {
		width: 1200px;
		background-color: white;
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		margin-top: 20px;
		margin-bottom: 20px;
	}
</style>
